
import React, { useState, useContext, useEffect } from 'react';
import ProcessButton from '../ProcessButton/ProcessButton.component';
import { FunctionContext } from '../../contexts/function.context';

const ActionForm = (props) => {
  const { currentFunctionCode } = useContext(FunctionContext);

  // UI/form management
  const [executing, setExecuting] = useState(false);

  const [executeButtonActions, setExecuteButtonActions] = useState(null);
  const [executeButtonResult, setExecuteButtonResult] = useState(null);

  useEffect(() => {
    setExecuteButtonActions('');
    setExecuteButtonResult([]);

  },[]);
 
  const onClickExecuteButton = () => {
  
      setExecuting(true);
      var resultlist = [];
      var resulttext = '';
      const apicontext = {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          //mode: 'no-cors', // no-cors, *cors, same-origin
          //cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          //credentials: 'include', // include, *same-origin, omit
          headers: {
            'Accept': '*/*',
            'Accept-Encoding': 'gzip, deflate, br',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*', 
            //'Access-Control-Allow-Credentials': true, 
            'x-functions-key': ''
          },
          //redirect: 'follow', // manual, *follow, error
          //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: {
              
          }
        };
      switch(props.envCode.toLowerCase()) {
          case 'dev':
              apicontext.headers['x-functions-key'] = process.env.REACT_APP_BATCHORCHESTRATORTOKEN_DEV
              break;
          case 'sit':
              apicontext.headers['x-functions-key'] = process.env.REACT_APP_BATCHORCHESTRATORTOKEN_SIT
              break;
          case 'uat':
              apicontext.headers['x-functions-key'] = process.env.REACT_APP_BATCHORCHESTRATORTOKEN_UAT
              break;
          case 'trg':
              apicontext.headers['x-functions-key'] = process.env.REACT_APP_BATCHORCHESTRATORTOKEN_TRG
              break;
              default:
              apicontext.headers['x-functions-key'] = ''
  
      
      }
      apicontext.body = JSON.stringify(currentFunctionCode.body);
      if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
          console.log(currentFunctionCode.url);
          console.log(JSON.stringify(apicontext));
      }
  //    fetch(functionURL, JSON.stringify(apicontext))
      fetch(currentFunctionCode.url, apicontext)
      .then((response) => response.json())
      .then(data => {
          if (data.id) {
            resultlist.push({name: 'getStatus', url: data.getStatus });
            resultlist.push({name: 'getEvents', url: data.getEvents });
            resultlist.push({name: 'stop', url: data.stop });
            resulttext = 'Success';
            setExecuteButtonActions(resultlist);
            setExecuteButtonResult(resulttext);
          } else {
            resultlist = [];
            resulttext = data.Message;
            setExecuteButtonActions(resultlist);
            setExecuteButtonResult(resulttext);
          }

          if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
            console.log('onClickExecuteButton data = ', data)
            console.log('onClickExecuteButton list = ', resultlist)
          }
      });
      setExecuting(false);    
  };

  // display form
  const DisplayForm = () => (
    <div>

      <button onClick={onClickExecuteButton}>
        Execute!
          </button>
    </div>
  )

  // display file name and image
  const DisplayExecutionCallbacks = () => {
      if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
        console.log('DisplayExecutionCallbacks');
      }   
      executeButtonActions.map((callback) => {
          if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
            console.log('DisplayExecutionCallbacks callback = ', JSON.stringify(callback));
          }               
          return (
          <div>
          <ProcessButton  key={callback.name } 
            buttonText={callback.name } 
            buttonUrl={callback.url} 
            fileName={callback.name }
            envCode={props.envCode}
          />
          </div>
            
        );
      })
    };

  const DisplayExecutionResult = () => {
    if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
      console.log('DisplayExecutionResult');
    }
    return (      
    <div>
        <div>
        <h2 key='display_execution_result_key'>{executeButtonResult}</h2>

        </div>
              
    </div>
    );
  };

  if (currentFunctionCode) {
    if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
      console.log(JSON.stringify(currentFunctionCode));
      console.log(JSON.stringify(executeButtonResult));
    }
    if (currentFunctionCode.type === 'Action') {
      return (
        <div>
          <h1>Execute {currentFunctionCode.code} job ( {currentFunctionCode.name} )</h1>
          {!executing && DisplayForm()}
          {executing && <div>Executing</div>}
          <hr />
          {console.log('ExecuteButtonActions = ',executeButtonActions )}
          {executeButtonActions && console.log('ExecuteButtonResult.length = ',executeButtonActions.length )}
          {executeButtonActions && executeButtonActions.length > 0 && DisplayExecutionCallbacks()}
          {console.log('ExecuteButtonResult = ',executeButtonResult )}
          {executeButtonResult && executeButtonResult !== '' && DisplayExecutionResult()}
        </div>
      );

    }
  
  }

};

export default ActionForm;